import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useLayoutContext } from "hooks/routerHooks";

import { LoadConfigParameters } from "components/loader/LoadConfigParameters";
import { DrawMeasureAreaSkeleton } from "components/skeletons/DrawMeasureAreaSkeleton";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";

export function DrawStudyAreaPage() {
  const { mapRef, footerRef, mapOverlayContainer } = useLayoutContext();

  return (
    <ErrorBoundary
      FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
    >
      <Suspense
        fallback={
          <DrawMeasureAreaSkeleton
            footerRef={footerRef}
            mapOverlayContainer={mapOverlayContainer}
          />
        }
      >
        <LoadConfigParameters mapRef={mapRef} footerRef={footerRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
